import {http} from "../http";
import {Company} from "../company";

interface AdditionCards{
    CardHolder: string;
    CardStat: string;
    Currency: string;
    EncryptedPan: string;
    ExpDate: string;
    MainStatus: string;
    Name: string;
    Pan: string;
    PaymentSys: string;
}

interface MainCards{
    AdditionNumb: number;
    BlockedDate: string;
    BlockedBy : string;
    CardHolder: string;
    CardStat: string;
    Currency: string;
    EncryptedPan: string;
    ExpDate: string;
    Iban: string;
    MainStatus: string;
    Name: string;
    Pan: string;
    PaymentSys: string;
    AdditionCards : AdditionCards[];
}

export interface OldCards{
    oldBusinessCards : {
        MsgStatus : string;
        MainCards : MainCards[]
    }
}

export interface OldCardBalanceRequest{
    encryptedPanList : any []
}

export interface OldCardBalanceResponse{
    businessCardsBalance : {
        MsgStatus : string;
        CardInfoResponses : {
            Pan : string;
            Balance? : number;
            BlockedBy : string;
        }[]
    }
}

export interface OldCardLimitResponse{
    businessCardsLimit : {
        MsgStatus : string;
        CardInfoResponses : {
            Pan : string;
            ResidualAmount? : number
        }[]
    }
}

export const getOldCards = async (customerNo: Company): Promise<OldCards> => {
    //${customerNo.customerNo}
    const { data } = await http.get<OldCards>(`brcards/get-old-business-cards-by-cif/${customerNo.customerNo}`);
    return data;
};

export const getOldCardBalance = async (customerNo: Company, post_data : OldCardBalanceRequest): Promise<OldCardBalanceResponse> => {
    //${customerNo.customerNo}
    const { data } = await http.post<OldCardBalanceResponse>(`brcards/get-old-business-cards-balance-by-pan/${customerNo.customerNo}`, post_data);
    return data;
}

export const getOldCardLimit = async (customerNo: Company, post_data : OldCardBalanceRequest): Promise<OldCardLimitResponse> => {
    //${customerNo.customerNo}
    const { data } = await http.post<OldCardLimitResponse>(`brcards/get-old-business-cards-limit-by-pan/${customerNo.customerNo}`, post_data);
    return data;
}
